document.querySelectorAll('.color-swatch').forEach(swatch => {
  swatch.addEventListener('click', function() {
    console.log('Swatch clicked:', this); // Add a console log to check if it's firing multiple times
    const newImageSrc = this.dataset.image;
    const productCard = this.closest('.product-card');
    const productImage = productCard.querySelector('.product-image img');

    if (productImage) {
      productImage.src = newImageSrc;
    }
  });
});
